/**
 * Repo-owned supplement to the `obscenity` library's built-in English
 * dataset. Edited by PR, same as the word lists — a term added here is
 * blocked everywhere {@link isProfane} is called (word-list test,
 * generation, admin rename) without waiting on an upstream release.
 *
 * Keep entries lowercase. Matched whole-word (word-boundary anchored, like
 * `obscenity`'s own dataset) so a short entry can't reject an unrelated word
 * that merely contains it as a substring — add the full token, not a
 * fragment.
 */
export const SPRINT_NAME_DENYLIST: readonly string[] = ['poopoo']
